import { useTranslation } from 'react-i18next'
import { Box } from '@chakra-ui/react'
import { colors } from '../../../utilities/colors'
import CarpoolVehiclesList from '../shared/CarpoolVehiclesList'
import LocationCard from './wizard/LocationCard'
import SectionLabel from './wizard/SectionLabel'

export default function QuoteSummary({ origin, destination, vehicles, priceOptions, stackLocations }) {
  const { t } = useTranslation()

  return (
    <Box display="flex" flexDirection="column" w="full" gap={4}>
      <Box display="flex" flexDirection={stackLocations ? 'column' : 'row'} gap={stackLocations ? 4 : 2}>
        <Box display="flex" flexDirection="column" gap={2} flex={1} minW={0}>
          <SectionLabel text={t('From')} accent={colors.yellow} />
          <LocationCard loc={origin} accent={colors.yellow} />
        </Box>

        <Box display="flex" flexDirection="column" gap={2} flex={1} minW={0}>
          <SectionLabel text={t('To')} accent="#4A90D9" />
          <LocationCard loc={destination} accent="#4A90D9" />
        </Box>
      </Box>
      <CarpoolVehiclesList vehicles={vehicles} />
    </Box>
  )
}
